module.exports = __webpack_public_path__ + "img/QOOKER_Box26.2df57f12.jpg";